// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { Product } from "../../../common/interfaces/conversionworld/Product";
import { Report } from "../../../common/interfaces/conversionworld/Report";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { StoryLink } from "../../common/story_link/StoryLink";
import { ProductLink } from "../product_list/product_link/ProductLink";
import { BodybuilderLink } from "../abh_overview_page_module/bodybuilder_link/BodybuilderLink";
import { Headline } from "../../../components/headline/Headline";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    StoryLink,
    ProductLink,
    BodybuilderLink,
    Headline,
  },
})
export class ReportNbaModule extends ModuleBase {
  private abhs: BodyBuilder[] = [];
  private products: Product[] = [];
  private reports: Report[] = [];

  public getBackgroundColorFromInstance(instance: object) {
    if (instance["background"]) {
      return instance["background"];
    }

    return "black";
  }

  created() {
    this.loadData();
  }

  public loadData() {
    Promise.all<BodyBuilder>(
      this.instance["items"]
        .filter((i) => i["type"] === "abh")
        .map((i) =>
          Api.conversionWorldService.getBodyBuilder(
            i["id"],
            this.$store.page.page!.id
          )
        )
    ).then((abhs) => (this.abhs = abhs));

    Promise.all<Product>(
      this.instance["items"]
        .filter((i) => i["type"] === "product")
        .map((i) =>
          Api.conversionWorldService.getProduct(
            i["id"],
            this.$store.page.page!.id
          )
        )
    ).then(
      (abhs) =>
        (this.products = abhs.filter(
          (p) =>
            p.technical_data.countries.some(
              (country) =>
                country.abbreviation === this.$store.ui.appCurrentCountry
            ) || this.$store.ui.appCurrentCountry === "GLOBAL"
        ))
    );

    Api.conversionWorldService
      .getReports(
        this.instance["items"]
          .filter((i) => i["type"] === "story")
          .map((i) => i["story_id"]),
        this.$store.page.page!.id
      )
      .then((reports) => (this.reports = reports));
  }

  public get entries() {
    let result: object[] = [];
    this.instance["items"].forEach((item) => {
      if (item["type"] === "abh") {
        let bodybuilder = this.abhs.find((b) => b.id == item["id"]);

        if (bodybuilder) {
          result.push({
            type: item["type"],
            data: bodybuilder,
          });
        }
      } else if (item["type"] === "product") {
        let product = this.products.find((b) => b.id == item["id"]);

        if (product) {
          result.push({
            type: item["type"],
            data: product,
          });
        }
      } else if (item["type"] === "story") {
        let report = this.reports.find((b) => b.id == item["story_id"]);

        if (report) {
          result.push({
            type: item["type"],
            data: report,
            story_highlight_text: item["story_highlight_text"],
          });
        }
      }
    });

    return result;
  }
}
